import React, { useRef } from "react";
import type { ResearchLens } from "../data/research";

const LENSES: readonly ResearchLens[] = ["patient", "provider"];
export function PerspectiveToggle({
  value,
  onChange,
}: {
  value: ResearchLens;
  onChange: (lens: ResearchLens) => void;
}) {
  const refs = useRef<(HTMLButtonElement | null)[]>([]);
  return (
    <div
      className="ui-segmented"
      role="radiogroup"
      aria-label="Choose your perspective"
      onKeyDown={(event) => {
        if (
          ![
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End",
          ].includes(event.key)
        )
          return;
        event.preventDefault();
        const index =
          event.key === "Home"
            ? 0
            : event.key === "End"
            ? 1
            : 1 - LENSES.indexOf(value);
        onChange(LENSES[index]);
        refs.current[index]?.focus();
      }}
    >
      {LENSES.map((lens, index) => (
        <button
          key={lens}
          ref={(el) => {
            refs.current[index] = el;
          }}
          type="button"
          role="radio"
          aria-checked={value === lens}
          tabIndex={value === lens ? 0 : -1}
          onClick={() => onChange(lens)}
          style={{ minHeight: 48 }}
        >
          {lens === "patient" ? "Patient" : "Healthcare provider"}
        </button>
      ))}
    </div>
  );
}
